import { AppState } from '../../redux/initialStates/AppState';
import { TagsListState } from './TagsListState';

export const selectTagsListState = (state: AppState): TagsListState => state.menuBuilder.tagsList;
